import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import {
  isScreenBelow640,
  isScreenBelow800,
  isScreenBelow1004,
} from 'store/common/settings/breakpoint/selectors';

import { Consumer } from './context';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const valignToClassBindings = {
  top: null,
  middle: 'valignMiddle',
  bottom: 'valignBottom',
};
const mapValignToClass = (key) =>
  key in valignToClassBindings ? valignToClassBindings[key] : null;

/**
 * Layout for non adaptive 12-grid column,
 */
export class BaseCol extends React.Component {
  /**
   * returns number for column-based grid, or nothing for 12 column or unknown number of columns
   */
  getSizeModifier = () => {
    const { size } = this.props;
    if (!size) return '';
    if (!this.isGridSize()) return '-fixed';
    return `-${size}`;
  };

  /**
   * test if size is percentage, rather than columns
   */
  isGridSize = () => {
    const { size } = this.props;
    return typeof size === 'number';
  };

  /**
   * for percentage-based columns returns style object extended with width
   */
  injectStyles = (baseStyles) => {
    const { size } = this.props;
    if (this.isGridSize()) return baseStyles;
    return { ...baseStyles, [this.isGridSize() ? 'width' : 'flexBasis']: size };
  };

  render() {
    const { children, className, valign, size } = this.props;
    const classes = cx(`columns${this.getSizeModifier()}`, mapValignToClass(valign), className);

    return (
      size !== 0 && (
        <Consumer>
          {({ colStyle } = {}) => (
            <div className={classes} style={this.injectStyles(colStyle)}>
              {children}
            </div>
          )}
        </Consumer>
      )
    );
  }
}

BaseCol.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  valign: PropTypes.oneOf(['middle', 'bottom']),
};

/**
 * Remapping for size array:
 * if omited, automatic layout applied
 * if one value is provided,     [0]: all resolutions
 * if two values are provided,   [0]: desktop, [1]: tablet
 * if three values are provided, [0]: desktop, [1]: tablet, [2]: mobile
 * if you want to use desktop and mobile, skipping tablet, leave second argument null
 */
const mapStateToProps = (state, { size = null, l = null, m = null, s = null }) => {
  if (s !== null && isScreenBelow640(state)) return { size: s };
  if (m !== null && isScreenBelow800(state)) return { size: m };
  if (l !== null && isScreenBelow1004(state)) return { size: l };
  return { size };
};

/**
 * omit l, m, s
 */
const mergeProps = (mapProps, dispatchProps, { l, m, s, ...ownProps }) => ({
  ...ownProps,
  ...mapProps,
  ...dispatchProps,
});

/**
 * Requires shop redux store to work,
 * provides adaptivity to column components
 */
const Col = connect(mapStateToProps, null, mergeProps)(BaseCol);

Col.propTypes = {
  /** Array of adaptive sizes, is provided for 12-grid layout */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  l: PropTypes.number,
  m: PropTypes.number,
  s: PropTypes.number,
  children: PropTypes.node, // inheritedProps
  valign: PropTypes.oneOf(['middle', 'bottom']), // inheritedProps
  className: PropTypes.string,
};

export default Col;
